import LegalDocumentsPage from '@pages/settings/legal-documents/LegalDocumentsPage'
import { Navigate, RouteObject } from 'react-router-dom'
import LegalDocumentDetailRoutes from './LegalDocumentDetailRoutes'

const legalDocumentRoutes: RouteObject[] = [
  {
    children: [
      { path: 'list', element: <LegalDocumentsPage /> },
      { index: true, element: <Navigate to="list" replace /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
  {
    path: ':legalDocumentSlug',
    children: LegalDocumentDetailRoutes,
  },
]

export default legalDocumentRoutes
